import { routes } from "@/routes/utils";
import { FileText, LayoutDashboard, User, UserCheck } from "lucide-react";
import { Handshake } from "lucide-react";

export const menus = [
  {
    to: `/${routes.admin}/${routes.latestNews}`,
    title: "Latest News",
    icon: LayoutDashboard,
  },
  {
    to: `/${routes.admin}/${routes.strategicInvestment}`,
    title: "Strategic Investment",
    icon: User,
  },
  {
    to: `/${routes.admin}/${routes.newsMedia}`,
    title: "News & Media",
    icon: FileText,
  },
  {
    to: `/${routes.admin}/${routes.financialReporting}`,
    title: "Financial Reporting",
    icon: FileText,
  },
  {
    to: `/${routes.admin}/${routes.annualReporting}`,
    title: "Annual Reporting",
    icon: FileText,
  },
  {
    to: `/${routes.admin}/${routes.jobPosting}`,
    title: "Job Posting",
    icon: UserCheck,
  },
  {
    to: `/${routes.admin}/${routes.investorInfoMBAPL}`,
    title: "Investor Info. MBAPL",
    icon: Handshake,
  },
  {
    to: `/${routes.admin}/${routes.investorInfoKPL}`,
    title: "Investor Info. KPL",
    icon: Handshake,
  },
];
